import React from 'react';
import {connect} from 'react-redux';
import mapDispatch from '~/misc/mapDispatch';
import cs from 'classnames'
import css from './index.css'
import Button from '~/components/common/Button';
import {modalClose, modalChange} from '~/modules/modal/actions';
import * as modes from '~/modules/modal/modes';
import accounting from '~/misc/accounting'
const textRenderFn = (type)  => (name, price) => {
  if(type === 'success') return `You’ve sent an offer to ${name} for ${price}`;
  return `You offer sent to ${name} for ${price} is failed`
}


class DotConfirm extends React.Component {
  constructor(props) {
    super(props)
  }
  render() {
    const { context,closePop } = this.props;
    const { confirm, dot, company } = context ; 
    return (
      <div className={css.popwrap}>
        <div className={css.booksentloadsmartWarp}>
        <main className={css.bookingMainNormal}>
          The DOT number you entered is <span className={css.strongFont}>{dot}</span>, company name: <span className={css.strongFont}>{company}</span>. Please note that once you’ve confirmed this, you will not be able to change it
        </main>
        <footer className={css.bookingFooter}>
          <div className={css.bookingFooterRow}>
            <Button
              mods={['action']}
              className={css.button}
              onClick={()=>{
                closePop();
                confirm();
              }}
            >
              Confirm
            </Button>
          </div>
        </footer>
        </div>
      </div>
    )
  }
}

export default connect(null, mapDispatch({
  closePop: () => modalClose(modes.DOT_CONFIRM),
}))(DotConfirm);


// WEBPACK FOOTER //
// ./src/components/Popup/DotConfirm/index.js